import * as Yup from "yup";

import { MessageType, TransMsg } from "../../i18n/messages";

const createPosCustomerValidationSchema = (t: (msg: TransMsg) => string, msg: MessageType) =>
  Yup.object().shape({
    email: Yup.string().when("regType", ([regType], schema) => {
      return regType === "email" || regType === "emailAndTel" ? schema.required() : schema;
    }),
    firstName: Yup.string().required(t(msg.form.firstNameR)),
    lastName: Yup.string().required(t(msg.form.lastNameR)),
    mobileNumber: Yup.string().when("regType", ([regType], schema) => {
      return regType === "tel" || regType === "emailAndTel" ? schema.required() : schema;
    }),
    regType: Yup.string(),
    remarks: Yup.string(),
    refNumber: Yup.string(),
  });

export { createPosCustomerValidationSchema };
